import React from 'react';
import '../scss/components/notification.scss';

const Notification = ({isShowInformation, adminName, logoutSuccessFunc,changeStore, removeNotification, notificationArray}) => {

  let changeStoreBtn = (
  <button className="btn btn-full success " onClick={changeStore}>切換分店</button>
  );
  if(!localStorage.getItem('all_store_id')){
    localStorage.setItem('all_store_id','1,2')
  }

  if (localStorage.getItem('all_store_id').length === 1){
    changeStoreBtn = '';
  }

    return (
      <div className={isShowInformation ? "account-information active" : "account-information"}>
        <div className="admin-name">
          {adminName} 您好!
        </div>
        <div className="u-btn-group center">
        {changeStoreBtn}
        <button className="btn btn-full cancel " onClick={logoutSuccessFunc}>登出</button>
        </div>
      </div>

    )
}

export default Notification;